<style scoped>
.form-control {
  height: 40px;
}
</style>

<template>
  <div>
    <label class="form-label">{{ label || "Resultate" }}</label>
    <input
      class="form-control"
      type="number"
      :min="0"
      :value="value"
      @input="emitFilter"
    />
  </div>
</template>

<script lang="babel">
export default {
    props: ['value', 'label', 'id'],
    methods: {
      emitFilter(event) {
        this.$emit('filter-change', {
          id: this.id,
          name: 'take',
          value: event.target.value
        });
      }
    }
};
</script>
